import { db } from '../firebase'

  const publishUserSyncRequest = (companyId, userId) => {
    const odooSyncPayload = {
            entity: 'USER',
            company_id: companyId,
            user_id: userId
          }
    db.ref('odooSync').push().set(odooSyncPayload)
  }

  export {publishUserSyncRequest}
